export const checkAcceptedFileTypes = (file: File, accept?: string[]) => {
  if (!accept || !accept.length) return true;
  const fileType = file.type;
  const fileExtension = file.name.match(/\.[0-9a-z]+$/i)?.[0];

  if (accept.some((a) => a === fileType || a === fileExtension)) {
    return true;
  }

  const hasWildCardType = accept.some((x) =>
    x.includes('/*')
      ? x.replace('/*', '/') === fileType.replace(/\/[0-9a-z]+$/, '/')
      : [],
  );

  return hasWildCardType;
};
